import { Avatar, IconButton } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import type { UserInfo } from "firebase/auth";
import type { FC } from "react";
import { auth } from "../auth/auth";

interface Props {
  readonly user: UserInfo | null;
}

const User: FC<Props> = ({ user }) => {
  const queryClient = useQueryClient();

  const logout = async () => {
    if (confirm("Czy chcesz się wylogować?")) {
      await auth.signOut();
      queryClient.clear();
    }
  };

  if (!user) {
    return <div />;
  }

  return (
    <div title={user.displayName + "\n" + "Kliknij aby się wylogować"}>
      <IconButton onClick={logout} style={{ padding: 0 }}>
        <Avatar src={user.photoURL ?? undefined} />
      </IconButton>
    </div>
  );
};

export default User;
